'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotFound = NotFound;

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _reactRouterDom = require('react-router-dom');

var _Fab = require('@material-ui/core/Fab');

var _Fab2 = _interopRequireDefault(_Fab);

var _Home = require('@material-ui/icons/Home');

var _Home2 = _interopRequireDefault(_Home);

var _styles = require('@material-ui/core/styles');

var _BodyClass = require('../BodyClass');

var _BodyClass2 = _interopRequireDefault(_BodyClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var styles = {
  body: {
    background: '#ddd'
  },
  wrapper: {
    alignItems: 'center',
    display: 'flex',
    height: '100%',
    left: '0',
    top: '0',
    width: '100%'
  },
  content: {
    boxSizing: 'border-box',
    margin: '0 auto',
    maxWidth: '320px',
    padding: '20px 30px',
    textAlign: 'center'
  },
  heading: {
    fontWeight: '300',
    fontSize: '34px',
    margin: '0',
    opacity: '.75'
  },
  subheading: {
    fontWeight: '400',
    fontSize: '18px',
    lineHeight: '1.5',
    margin: '1.8em 10px 2em',
    opacity: '.5'
  }
};

var _ref = React.createElement(_Home2.default, null);

function NotFound(props) {
  var classes = props.classes,
      route = props.route,
      title = props.title;

  return React.createElement(
    'div',
    { className: classes.wrapper },
    React.createElement(_BodyClass2.default, { classNames: classes.body }),
    React.createElement(
      'div',
      { className: classes.content },
      React.createElement(
        'div',
        { className: classes.heading },
        'Page Not Found'
      ),
      React.createElement(
        'div',
        { className: classes.subheading },
        'The page you requested is not available.'
      ),
      React.createElement(
        _Fab2.default,
        { component: _reactRouterDom.Link, role: 'link', to: route, title: title, 'aria-label': title, color: 'primary' },
        _ref
      )
    )
  );
}

NotFound.defaultProps = {
  route: '/',
  title: 'Home',
  classes: {}
};

exports.default = (0, _styles.withStyles)(styles)(NotFound);